import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { Button, Spinner } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { apiCall } from "utils/httpClient";
import apiEndPoint from "utils/apiEndPoint";
import { isEmpty } from "utils/utils";
import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";

function HomeTabSlider({ selectCategoryId, setSelectCategoryId,selectedCategoryId,setSelectedCategoryId, searchCategory, handleAllTemplateData, languageData, setCurrentPage }) {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const sliderRef = useRef(null); // <-- Add ref

    const getCategoryList = async () => {
        let params = {};
        setLoading(true);
        if (!isEmpty(searchCategory)) {
            params["category_name"] = searchCategory;
        }
        const { data } = await apiCall("post", apiEndPoint.GETCATEGORY, params);
        if (data.status === 200) {
            setCategories(data.data);
        } else {
            setCategories([]);
        }
        setLoading(false);
    };

    useEffect(() => {
        getCategoryList();
    }, [searchCategory]);

    const settings = {
        dots: false,
        infinite: categories.length > 1,
        speed: 500,
        variableWidth: true,
        slidesToScroll: 1,
        arrows: false, // Disable default arrows
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: false,
    };

    return (
        <>
            <div className="tab-slider-container" style={{ width: "100%", display: 'flex', gap: 10, alignItems: 'center' }}>
                <span
                    className="d-none d-md-block"
                    style={{ fontWeight: 600, fontSize: 12, color: '#046a38' }}
                >
                    Trending Templates
                </span>                {loading ? (
                    <div style={{ textAlign: "center", marginLeft: "10px" }}>
                        <Spinner animation="border" variant="primary" size="sm" />
                    </div>
                ) : (
                    categories.length > 0 && (
                        <>
                            <Slider {...settings} ref={sliderRef} className="custom-hometabslider-width">
                                {categories.map((item, i) => (
                                    <p
                                        key={i}
                                        className={`category-slickbtn ${selectedCategoryId === item?._id ? 'active' : ''}`}
                                        onClick={() => {
                                            setSelectCategoryId(item?._id);
                                            setSelectedCategoryId(item?._id);
                                            setCurrentPage(0);
                                        }}
                                    >
                                        {item?.category_name}
                                    </p>
                                ))}
                            </Slider>
                           
                            <div style={{ position: 'relative', top: '-2px' }}>
                                <Button onClick={() => sliderRef.current?.slickPrev()} style={{ borderRadius: 50 }}>
                                    <FaChevronLeft />
                                </Button>
                                <Button onClick={() => sliderRef.current?.slickNext()} style={{ borderRadius: 50, marginLeft: 5 }}>
                                    <FaChevronRight />
                                </Button>
                            </div>
                        </>
                    )
                )}
            </div>
        </>
    );
}

export default HomeTabSlider;
